export default __webpack_public_path__ + "static/media/Spring blue vase_primary.dea77d70.jpg";